/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PatchedShiftRequest,
  Shift,
  ShiftRequest,
  ShiftsListParams,
  ShiftsSuggestedBreaksListParams,
  SuggestedBreak
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getShiftsListUrl = (params: ShiftsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/shifts/?${stringifiedParams}` : `/api/shifts/`
}

/**
 * Retrieves the list of shifts stored by location.
 */
export const shiftsList = async (params: ShiftsListParams, options?: Parameters<typeof customFetch>[1]): Promise<Shift[]> => {

  return customFetch<Shift[]>(getShiftsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShiftsListQueryKey = (params?: ShiftsListParams,) => {
    return [
    `/api/shifts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getShiftsListQueryOptions = <TData = Awaited<ReturnType<typeof shiftsList>>, TError = void>(params: ShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShiftsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shiftsList>>> = ({ signal }) => shiftsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shiftsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShiftsListQueryResult = NonNullable<Awaited<ReturnType<typeof shiftsList>>>
export type ShiftsListQueryError = void


export function useShiftsList<TData = Awaited<ReturnType<typeof shiftsList>>, TError = void>(
 params: ShiftsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shiftsList>>,
          TError,
          Awaited<ReturnType<typeof shiftsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShiftsList<TData = Awaited<ReturnType<typeof shiftsList>>, TError = void>(
 params: ShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shiftsList>>,
          TError,
          Awaited<ReturnType<typeof shiftsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShiftsList<TData = Awaited<ReturnType<typeof shiftsList>>, TError = void>(
 params: ShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShiftsList<TData = Awaited<ReturnType<typeof shiftsList>>, TError = void>(
 params: ShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShiftsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getShiftsCreateUrl = () => {




  return `/api/shifts/`
}

export const shiftsCreate = async (shiftRequest: ShiftRequest, options?: Parameters<typeof customFetch>[1]): Promise<Shift> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Shift>(getShiftsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(shiftRequest)
  }
);}





export const getShiftsCreateMutationKey = () => ['shiftsCreate'] as const;

export const getShiftsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shiftsCreate>>, TError,ShiftsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shiftsCreate>>, TError,ShiftsCreateMutationVariables, TContext> => {

const mutationKey = getShiftsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shiftsCreate>>, ShiftsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  shiftsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShiftsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof shiftsCreate>>>
    export type ShiftsCreateMutationBody = ShiftRequest
    export type ShiftsCreateMutationError = void
    export type ShiftsCreateMutationVariables = {data: ShiftRequest}

    export const useShiftsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shiftsCreate>>, TError,ShiftsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shiftsCreate>>,
        TError,
        ShiftsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getShiftsCreateMutationOptions(options), queryClient);
    }
    export const getShiftsRetrieveUrl = (id: number,) => {




  return `/api/shifts/${id}/`
}

export const shiftsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Shift> => {

  return customFetch<Shift>(getShiftsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShiftsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/shifts/${id}/`
    ] as const;
    }


export const getShiftsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof shiftsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShiftsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shiftsRetrieve>>> = ({ signal }) => shiftsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shiftsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShiftsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof shiftsRetrieve>>>
export type ShiftsRetrieveQueryError = void


export function useShiftsRetrieve<TData = Awaited<ReturnType<typeof shiftsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shiftsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof shiftsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShiftsRetrieve<TData = Awaited<ReturnType<typeof shiftsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shiftsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof shiftsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShiftsRetrieve<TData = Awaited<ReturnType<typeof shiftsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShiftsRetrieve<TData = Awaited<ReturnType<typeof shiftsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShiftsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getShiftsUpdateUrl = (id: number,) => {




  return `/api/shifts/${id}/`
}

export const shiftsUpdate = async (id: number,
    shiftRequest: ShiftRequest, options?: Parameters<typeof customFetch>[1]): Promise<Shift> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Shift>(getShiftsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(shiftRequest)
  }
);}





export const getShiftsUpdateMutationKey = () => ['shiftsUpdate'] as const;

export const getShiftsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shiftsUpdate>>, TError,ShiftsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shiftsUpdate>>, TError,ShiftsUpdateMutationVariables, TContext> => {

const mutationKey = getShiftsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shiftsUpdate>>, ShiftsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  shiftsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShiftsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof shiftsUpdate>>>
    export type ShiftsUpdateMutationBody = ShiftRequest
    export type ShiftsUpdateMutationError = void
    export type ShiftsUpdateMutationVariables = {id: number;data: ShiftRequest}

    export const useShiftsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shiftsUpdate>>, TError,ShiftsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shiftsUpdate>>,
        TError,
        ShiftsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getShiftsUpdateMutationOptions(options), queryClient);
    }
    export const getShiftsPartialUpdateUrl = (id: number,) => {




  return `/api/shifts/${id}/`
}

export const shiftsPartialUpdate = async (id: number,
    patchedShiftRequest?: PatchedShiftRequest, options?: Parameters<typeof customFetch>[1]): Promise<Shift> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Shift>(getShiftsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedShiftRequest)
  }
);}





export const getShiftsPartialUpdateMutationKey = () => ['shiftsPartialUpdate'] as const;

export const getShiftsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shiftsPartialUpdate>>, TError,ShiftsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shiftsPartialUpdate>>, TError,ShiftsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getShiftsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shiftsPartialUpdate>>, ShiftsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  shiftsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShiftsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof shiftsPartialUpdate>>>
    export type ShiftsPartialUpdateMutationBody = PatchedShiftRequest | undefined
    export type ShiftsPartialUpdateMutationError = void
    export type ShiftsPartialUpdateMutationVariables = {id: number;data?: PatchedShiftRequest}

    export const useShiftsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shiftsPartialUpdate>>, TError,ShiftsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shiftsPartialUpdate>>,
        TError,
        ShiftsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getShiftsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getShiftsDestroyUrl = (id: number,) => {




  return `/api/shifts/${id}/`
}

export const shiftsDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getShiftsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getShiftsDestroyMutationKey = () => ['shiftsDestroy'] as const;

export const getShiftsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shiftsDestroy>>, TError,ShiftsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shiftsDestroy>>, TError,ShiftsDestroyMutationVariables, TContext> => {

const mutationKey = getShiftsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shiftsDestroy>>, ShiftsDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  shiftsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShiftsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof shiftsDestroy>>>

    export type ShiftsDestroyMutationError = void
    export type ShiftsDestroyMutationVariables = {id: number}

    export const useShiftsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shiftsDestroy>>, TError,ShiftsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shiftsDestroy>>,
        TError,
        ShiftsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getShiftsDestroyMutationOptions(options), queryClient);
    }
    export const getShiftsSuggestedBreaksListUrl = (id: number,
    params?: ShiftsSuggestedBreaksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/shifts/${id}/suggested-breaks/?${stringifiedParams}` : `/api/shifts/${id}/suggested-breaks/`
}

export const shiftsSuggestedBreaksList = async (id: number,
    params?: ShiftsSuggestedBreaksListParams, options?: Parameters<typeof customFetch>[1]): Promise<SuggestedBreak[]> => {

  return customFetch<SuggestedBreak[]>(getShiftsSuggestedBreaksListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShiftsSuggestedBreaksListQueryKey = (id: number,
    params?: ShiftsSuggestedBreaksListParams,) => {
    return [
    `/api/shifts/${id}/suggested-breaks/`, ...(params ? [params] : [])
    ] as const;
    }


export const getShiftsSuggestedBreaksListQueryOptions = <TData = Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError = void>(id: number,
    params?: ShiftsSuggestedBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShiftsSuggestedBreaksListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>> = ({ signal }) => shiftsSuggestedBreaksList(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShiftsSuggestedBreaksListQueryResult = NonNullable<Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>>
export type ShiftsSuggestedBreaksListQueryError = void


export function useShiftsSuggestedBreaksList<TData = Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError = void>(
 id: number,
    params: undefined |  ShiftsSuggestedBreaksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>,
          TError,
          Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShiftsSuggestedBreaksList<TData = Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError = void>(
 id: number,
    params?: ShiftsSuggestedBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>,
          TError,
          Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShiftsSuggestedBreaksList<TData = Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError = void>(
 id: number,
    params?: ShiftsSuggestedBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShiftsSuggestedBreaksList<TData = Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError = void>(
 id: number,
    params?: ShiftsSuggestedBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shiftsSuggestedBreaksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShiftsSuggestedBreaksListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






